import React from "react";
import { Typography } from "@mui/material";

interface ElectricityTextsProps {
  text: string;
}

const ElectricityTexts: React.FC<ElectricityTextsProps> = ({ text }) => {
  return (
    <Typography
      sx={{
        fontSize: { xs: "20px", md: "5vw", lg: "60px" },
        color: "#09507F",
        whiteSpace: "wrap",
        marginBottom: { xs: "10%", sm: "10%", md: "6%", lg: "2%" },
      }}
      align="center"
      variant="body2"
      padding={{ xs: "0 10%", sm: "0 10%", md: "0 10%", lg: "0 5%" }}
    >
      {text}
    </Typography>
  );
};

// Usage of the ElectricityTexts component
const text = "How fixed rate plans make it easier to save on your electricity bills";

const ElectricityTextsContainer: React.FC = () => {
  return <ElectricityTexts text={text} />;
};

export default ElectricityTextsContainer;
